import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

export interface ExternalLinkIframeState {
  url: string | null
  isOpen: boolean
}

export const externalLinkIframeInitialState: ExternalLinkIframeState = {
  url: null,
  isOpen: false,
}

const slice = createSlice({
  name: 'externalLinkIframe',
  initialState: externalLinkIframeInitialState,
  reducers: {
    openExternalLinkIframe: (state, action: PayloadAction<string>) => {
      state.url = action.payload
      state.isOpen = true
    },
    closeExternalLinkIframe: (state) => {
      state.url = null
      state.isOpen = false
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => externalLinkIframeInitialState)
  },
})

export const { openExternalLinkIframe, closeExternalLinkIframe } = slice.actions

const { reducer } = slice
export default reducer
